export const saloon1ImageOptions = {
  angle: 'saloon1',
  staticOptions: {
    Floorboard: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    SplitBerth: 1,
    Backrest: 1,
    TableBox: 1,
    FabricOwnersCabin: 1,
    FabricAftCabin: 1,
    AftCabinShelving: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: 'Pouffes'
    },
    {
      option: 'CupboardsSaloon',
      dependency: 'Veneer'
    },
    {
      option: 'CupboardsOwnersCabin',
      dependency: 'Veneer'
    },
    {
      option: 'Backrest',
      dependency: 'Fabric'
    },
    {
      option: 'TableBox',
      dependency: 'Veneer'
    },
    {
      option: 'FabricOwnersCabin',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X46/views/saloon1.js